import { BarElement, CategoryScale, Chart as ChartJS, Filler, Legend, LinearScale, LineElement, PointElement, Tooltip } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Filler, Tooltip, Legend);

/** Shared chart options: quiet grid, solid tooltip, no fade animation on the tooltip. */
export const baseOptions = (opts: { stepSize?: number } = {}): any => ({
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { animation: { duration: 0 }, backgroundColor: '#0f172a', padding: 10, cornerRadius: 8, displayColors: false,
      titleFont: { size: 12, weight: 'bold' }, bodyFont: { size: 12 } },
  },
  scales: {
    x: { grid: { display: false }, border: { display: false }, ticks: { color: '#94a3b8', font: { size: 11 }, maxRotation: 0, autoSkipPadding: 12 } },
    y: { beginAtZero: true, grid: { color: 'rgba(148,163,184,.15)' }, border: { display: false },
      ticks: { color: '#94a3b8', font: { size: 11 }, precision: 0, ...(opts.stepSize ? { stepSize: opts.stepSize } : {}) } },
  },
});
